import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const AddPatient = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    city: "",
    pin_code: "",
    language: "",
    date_of_birth: "",
    gender: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const formattedDOB = new Date(formData.date_of_birth)
        .toLocaleDateString("en-GB"); // dd/mm/yyyy

      const patientPayload = {
        ...formData,
        date_of_birth: formattedDOB,
      };

      const response = await fetch("https://www.careplus.gopillz.com/add_doctor_patient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(patientPayload),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({ type: "success", text: "Patient added successfully!" });
        setTimeout(() => navigate("/doctor-dashboard"), 1500);
      } else {
        setMessage({ type: "error", text: data?.error || "Failed to add patient." });
      }
    } catch (error) {
      setMessage({ type: "error", text: "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="flex justify-center items-start px-4 pt-24 pb-10 min-h-screen bg-blue-50">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-2xl space-y-6"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-blue-700 mb-4">Add New Patient</h2>

          {loading && (
            <div className="text-blue-600 text-sm mb-4 animate-pulse">Submitting, please wait...</div>
          )}

          {message.text && (
            <div
              className={`text-sm font-medium px-4 py-2 rounded mb-4 ${message.type === "success"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
                }`}
            >
              {message.text}
            </div>
          )}

          <div>
            <label className="block text-gray-700 font-medium mb-1">Name</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="Enter full name"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Phone Number</label>
            <PhoneInput
              country={"in"}
              value={formData.phone_number}
              onChange={(phone) =>
                setFormData((prev) => ({ ...prev, phone_number: phone }))
              }
              inputStyle={{
                width: "100%",
                borderRadius: "0.5rem",
                padding: "0.5rem 1rem",
                border: "1px solid #d1d5db", // Tailwind border-gray-300
              }}
              inputClass="text-sm"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 font-medium mb-1">Date of Birth</label>
              <input
                type="date"
                name="date_of_birth"
                required
                value={formData.date_of_birth}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Gender</label>
              <select
                name="gender"
                required
                value={formData.gender}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">City</label>
            <input
              type="text"
              name="city"
              required
              value={formData.city}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="Enter city"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Pin Code</label>
            <input
              type="text"
              name="pin_code"
              required
              value={formData.pin_code}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="Enter area pin code"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Preferred Language</label>
            <select
              name="language"
              required
              value={formData.language}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
            >
              <option value="">Select Language</option>
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
            </select>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-semibold px-6 py-2 rounded-full shadow-lg transition hover:scale-105"
            >
              {loading ? "Adding..." : "Add Patient"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddPatient;
